import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "linux_manjaro",
  "use": "linux_manjaro-usage",
  "viewBox": "0 0 14 14",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 14 14\" id=\"linux_manjaro\"><path d=\"M9.049 0H0v14h4.084V4.097h4.965zM14 0H9.903v14H14z\" /><path d=\"M9.049 4.951H4.95V14H9.05z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol